import { RouteConfig } from 'vue-router';

/* eslint-disable @typescript-eslint/explicit-function-return-type */
const redirectRoutes: Array<RouteConfig> = [
	{
		path: '/account/updates',
		name: 'account-updates-redirect',
		beforeEnter: async (to, from, next) => {
			next({ name: 'newsfeed', replace: true });
		}
	},
	{
		path: '/portfolio/:offeringId/updates',
		name: 'portfolio-updates-redirect',
		beforeEnter: async (to, from, next) => {
			next({ name: 'newsfeed', replace: true });
		}
	},
	{
		path: '/portfolio/:offeringId/documents',
		name: 'portfolio-documents-redirect',
		beforeEnter: async (to, from, next) => {
			next({ name: 'account-documents', replace: true });
		}
	},
	{
		path: '/portfolio/:offeringId/transactions',
		name: 'portfolio-transactions-redirect',
		beforeEnter: async (to, from, next) => {
			next({ name: 'account-transactions', replace: true });
		}
	},
	{
		path: '/portfolio/portfolio-investment/:compositeId/updates',
		name: 'composite-portfolio-redirect',
		beforeEnter: async (to, from, next) => {
			next({ name: 'newsfeed', replace: true });
		}
	},
	{
		path: '/portfolio/portfolio-investment/:compositeId/documents',
		name: 'composite-documents-redirect',
		beforeEnter: async (to, from, next) => {
			next({ name: 'account-documents', replace: true });
		}
	},
	{
		path: '/account/portfolio-investment/:compositeId/transactions',
		name: 'composite-transactions-redirect',
		beforeEnter: async (to, from, next) => {
			next({ name: 'account-transactions', replace: true });
		}
	},
	{
		path: '/portfolio/reit-investment/:reitId/updates',
		name: 'reit-updates-redirect',
		beforeEnter: async (to, from, next) => {
			next({ name: 'newsfeed', replace: true });
		}
	},
	{
		path: '/portfolio/reit-investment/:reitId/documents',
		name: 'reit-documents-redirect',
		beforeEnter: async (to, from, next) => {
			next({ name: 'account-documents', replace: true });
		}
	},
	{
		path: '/portfolio/reit-investment/:reitId/transactions',
		name: 'reit-transactions-redirect',
		beforeEnter: async (to, from, next) => {
			next({ name: 'account-transactions', replace: true });
		}
	},
	{
		path: '/account/upgrade/advanced/ira/direct',
		name: 'account-upgrade-advanced-ira-redirect',
		beforeEnter: async (to, from, next) => {
			next({ name: 'upgrade-landing', replace: true });
		}
	},
	{
		path: '/account/upgrade/basic-plan',
		name: 'account-upgrade-basic-plan-redirect',
		beforeEnter: async (to, from, next) => {
			next({ name: 'upgrade-landing', replace: true });
		}
	},
	{
		path: '/account/upgrade/:serviceLevel/success',
		name: 'account-upgrade-service-level-success-redirect',
		beforeEnter: async (to, from, next) => {
			next({ name: 'upgrade-success', replace: true });
		}
	},
	{
		path: '/account/invest-upgrade/select-starter',
		name: 'account-invest-upgrade-select-starter-redirect',
		beforeEnter: async (to, from, next) => {
			next({ name: 'add-funds-ria', replace: true });
		}
	},
	{
		path: '/account/upgrade/premium-welcome',
		name: 'account-upgrade-premium-welcome-redirect',
		beforeEnter: async (to, from, next) => {
			next({ name: 'account-overview', replace: true });
		}
	},
	{
		path: '/account/upgrade/:serviceLevel',
		name: 'account-upgrade-service-level-redirect',
		beforeEnter: async (to, from, next) => {
			next({ name: 'upgrade-landing', replace: true });
		}
	}
];

export default redirectRoutes;
